/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export const ICON_SET = {
  GROUP_EXPANDED:
    `<svg height="100%" viewBox="0 0 24 24" width="16" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path>
    </svg>`,
  GROUP_CONTRACTED:
    `<svg height="100%" viewBox="0 0 24 24" width="16" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
    </svg>`,
  SORT_ASCENDING:
    `<svg viewBox="0 0 24 24" height="10" width="10" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 14l5-5 5 5z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
    </svg>`,
  SORT_DESCENDING:
    `<svg viewBox="0 0 24 24" height="10" width="10" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 10l5 5 5-5z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
    </svg>`,
  EXTERNAL_FILTER:
    `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M19 5v14H5V5h14m1.1-2H3.9c-.5 0-.9.4-.9.9v16.2c0 .4.4.9.9.9h16.2c.4 0 .9-.5.9-.9V3.9c0-.5-.5-.9-.9-.9zM11 7h6v2h-6V7zm0 4h6v2h-6v-2zm0 4h6v2h-6zM7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7z"/>
        <path fill="none" d="M0 0h24v24H0z"/>
    </svg>`,
};
